var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWineWLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 1.26163L52.0057 37.9885C51.3456 42.664 49.2175 44 45.4016 44H41.4395C38.1374 44 36.3768 42.3674 35.3492 38.0629L29.5523 19.601C29.4053 18.9327 29.4053 18.784 29.1119 18.784C28.8186 18.784 28.7458 18.9327 28.5988 19.601L22.8012 38.0629C21.7742 42.3674 20.0137 44 16.7109 44H12.7495C8.93292 44 6.80483 42.664 6.1447 37.9885L0 1.26163V1.03931C0 0.370986 0.587316 0 1.24745 0H9.02547C9.61211 0 10.1994 0.519655 10.2722 1.33596L14.8034 33.907C14.8769 34.5746 14.8769 35.0199 15.1702 35.0199C15.4635 35.0199 15.4635 34.5746 15.6105 33.907L21.9206 13.8862C22.3616 12.1056 23.3885 10.5473 26.5435 10.5473H31.6075C34.7619 10.5473 35.7888 12.1056 36.2298 13.8862L42.5399 33.907C42.6869 34.5746 42.6869 35.0199 42.9809 35.0199C43.2735 35.0199 43.2735 34.5746 43.3477 33.907L47.7264 1.33596C47.8013 0.519655 48.3879 0 48.9738 0H56.7525C57.4134 0 58 0.370986 58 1.03931V1.26163Z",
    fill: "#EAEAEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineWLogo);
export default __webpack_public_path__ + "static/media/wine-w-logo.bd2aea7a98ed040bfbebb214420e7596.svg";
export { ForwardRef as ReactComponent };